import { BusinessError, InvalidTokenError, MinimumVersionWarning } from './ErrorTypes';
import * as msg from './Mensagens';
import configuration from '../envConfig';

export const responseHandler = (result) => {
  const response = result instanceof Error ? result.response : result;
  switch (response.status) {
    case 200:
      return response.data;
    case 204:
      return [];
    case 400: {
      if (response.data.detalhes) {
        if (
          response.data.detalhes[0]?.mensagemErro?.descricao ===
          msg.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA
        ) {
          throw new MinimumVersionWarning(
            configuration.isCordova
              ? msg.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA
              : msg.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB
          );
        } else {
          throw new BusinessError(response.data.detalhes[0]?.mensagemErro?.descricao);
        }
      }

      throw new BusinessError(msg.ERRO_GERAL_SISTEMA);
    }
    case 401:
      throw new InvalidTokenError(msg.ERRO_LOGIN_EXPIRADO);
    case 403: {
      const err403 = new BusinessError(response.data?.mensagemErro?.descricao);
      err403.codigo = response.data?.mensagemErro?.codigo;
      throw err403;
    }
    case 423:
      throw new BusinessError(msg.MSG_API_CAIXA_INDISPONIVEL_EM_PROCESSAMENTO);
    default:
      throw new BusinessError(msg.ERRO_GERAL_SISTEMA);
  }
};
